import { useState } from 'react';
import { Step, WIZARD_STEPS_COUNT } from '../calculatorSteps';
import type { CalculatorFormState } from '../types';

export const canAdvanceFromStep = (step: number, formData: CalculatorFormState): boolean => {
  if (step === Step.Challenges) return formData.challenges.length > 0;
  if (step === Step.Services) return formData.services.length > 0;
  if (step === Step.Workshop) return Boolean(formData.workshopType);
  return true;
};

export const useCalculatorSteps = (formData: CalculatorFormState, onExit: () => void) => {
  const [currentStep, setCurrentStep] = useState<number>(Step.Intro);

  const goNext = () => {
    if (!canAdvanceFromStep(currentStep, formData)) return;
    setCurrentStep(prev => prev + 1);
  };

  const goBack = () => {
    if (currentStep === Step.Intro) {
      onExit();
      return;
    }
    setCurrentStep(prev => prev - 1);
  };

  return {
    currentStep,
    totalSteps: WIZARD_STEPS_COUNT,
    goNext,
    goBack,
    goToStep: setCurrentStep,
    canAdvance: canAdvanceFromStep(currentStep, formData),
  };
};
